import {useEffect, useState } from "react";
import Link from "@mui/material/Link";
import CardContent from "@mui/material/CardContent";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import Typography from "@mui/material/Typography";
import Card from "@mui/material/Card";
import Div from "@jumbo/shared/Div";
import * as yup from "yup";
import { Form, Formik } from "formik";
import JumboTextField from "@jumbo/components/JumboFormik/JumboTextField";
import LoadingButton from "@mui/lab/LoadingButton";
import { useNavigate } from "react-router-dom";
import { axios_public } from "../../../axios";
import Box from "@mui/material/Box"; 
import { Button, CircularProgress, Modal, TextField } from "@mui/material";
import { toast } from "react-toastify";
import { passwordFieldSx } from "app/utils/constants/passwordFieldStyles";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

const validationSchema = yup.object({
    email: yup.string("Enter your email").email("Enter a valid email").required("Email is required"),
    password: yup.string("Enter your password").required("Password is required")
});

const AdminLogin = () => {
    const navigate = useNavigate();
    const [open, setOpen] = useState(false);
    const [email, setEmail] = useState("");
    const [rememberMe, setRememberMe] = useState(false);
    const [sendLinkLoader, setSendLinkLoader] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
        const handleClose = () => {
            if (!sendLinkLoader) {
                setOpen(false)
            }
        };
        const handleClick = () => setOpen(!open);
    
        const handleLink = e => {
            e.preventDefault();
            setSendLinkLoader(true);
    
            axios_public
                .post("/superAdmin/forgotpassword", { email: email.trim() })
                .then(() => {
                    toast.success(`Link sent to ${email}`);
                })
                .catch(() => {
                })
                .finally(() => {
                    setSendLinkLoader(false);
                    setOpen(false);
                });
        };
    const style = {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: 400,
        bgcolor: "background.paper",
        border: "2px solid #000",
        boxShadow: 24,
        p: 4
    };
    useEffect(() => {
        if (localStorage.getItem("TREXO_AUTH_TOKEN")) {
            navigate("/superadmin/apps");
        } else {
            navigate("/superAdmin/login");
        }
    }, []);

    const onSignIn = (email, password,rememberMe, setSubmitting) => {
        setSubmitting(true);
                axios_public
            .post("/superAdmin/login", { email, password,rememberMe})
            .then(res => {
                setSubmitting(false);
                if (res.status === 200 && res.data.token) {
                    localStorage.setItem("superadmin_username", res.data.fname + " " + res.data.lname);
                    localStorage.setItem("SUPERADMIN_USER_MAIL", res.data.email);
                    localStorage.setItem("TREXO_AUTH_TOKEN", res.data.token);

                    navigate("/superadmin/apps");
                } else {
                    setSubmitting(false);
                }
            })
            .catch(error => {
                setSubmitting(false);
            })
    };

    return (
            <Box
                sx={{
                    display: "flex",
                    justifyContent: 'center',
                    alignItems: "center",
                    width:'100%',
                    height: "100vh", 
                }}
            >
                <Card
                    sx={{width:'30%'}}
                >
                    <CardContent sx={{ flex: 1, p: 4 }}>
                        <Box sx={{ mt: "auto", mb: 4 }}>
                            <img src={"/images/logo.png"} alt="Trexo Global"  style={{width: "50%",  height: "auto"}} />
                        </Box>
                        <Formik
                            validateOnChange={true}
                            initialValues={{
                                email: "",
                                password: ""
                            }}
                            validationSchema={validationSchema}
                            onSubmit={(data, { setSubmitting }) => {
                               
                                onSignIn(data.email, data.password,rememberMe, setSubmitting);
                                
                            }}
                        >
                            {({ isSubmitting }) => (
                                <Form style={{ textAlign: "left" }} autoComplete="off">
                                    <Div sx={{ mt: 1, mb: 3 }}>
                                        <JumboTextField fullWidth name="email" label="Email" />
                                    </Div>
                                    <Div sx={{ mt: 1, mb: 2 }}>
                                           <JumboTextField fullWidth name="password" label="Password" type={showPassword ? "text" : "password"}
                                            sx={passwordFieldSx}
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                    <IconButton
                                                        type="button"
                                                        edge="end"
                                                        onMouseDown={(e) => e.preventDefault()}
                                                        onClick={() => setShowPassword(prev => !prev)}
                                                        aria-label={showPassword ? "Hide password" : "Show password"}
                                                        title={showPassword ? "Hide password" : "Show password"}
                                                    >
                                                        {showPassword ? <VisibilityOff /> : <Visibility />}
                                                    </IconButton>
                                                    </InputAdornment>
                                                ),
                                            }}
                                        />
                                    </Div>
                                    <Div sx={{ mb: 2 }}>
                                        <FormControlLabel control={<Checkbox checked={rememberMe} onChange={(e) => {console.log("Checkbox value:", e.target.checked) ;setRememberMe(e.target.checked)}}/>} label="Remember me" />
                                    </Div>
                                    <Typography variant={"body1"} sx={{ mb: 2 }}>
                                        <Link href={"#"} color={"inherit"} underline={"none"} onClick={handleClick}>
                                            Forgot your password? Recover Now
                                        </Link>
                                    </Typography>
                                <Modal open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                                    <Div sx={style}>
                                        <Typography id="modal-modal-title" variant="h4" component="h2">
                                            <TextField label="Email" value={email} variant="outlined" fullWidth onChange={e => setEmail(e.target.value)} />
                                        </Typography>

                                        <Typography variant="body1" sx={{ mb: 2 }} style={{ fontSize: "small", color: "#010160" }}>
                                            A password reset link will be sent to the above email
                                        </Typography>

                                        <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                                            <Button type="submit" variant="contained" color="primary" onClick={handleLink} disabled={sendLinkLoader}>
                                                {sendLinkLoader ? <CircularProgress size={25} sx={{ color: "blue" }} /> : <span>Send Link</span>}
                                            </Button>
                                        </Typography>
                                    </Div>
                                </Modal>
                                    <LoadingButton fullWidth type="submit" variant="contained" size="large" sx={{ mb: 3 }} loading={isSubmitting}>
                                        Sign In
                                    </LoadingButton>
                                </Form>
                            )}
                        </Formik>
                    </CardContent>
                </Card>
            </Box>
    );
};

export default AdminLogin;